var exports = {
  "$": "search__5ly52E",
};

module.exports = exports;
